module.exports = "<div \n\tclass=\"product-category {{product.category.Name}}\" \n\tng-class=\"{'long':product.category.ProductTypes.length > 8}\">\n\t<h2>\n\t\t<!-- <span class=\"hicon-{{product.iconClass}}\"></span> -->\n\t\t<img ng-src=\"/src/assets/images/product-icons/icon-{{product.iconClass}}.svg\" ng-shadow>\n\t\t{{product.category.Name}}\n\t</h2>\n\t<ul>\n\t\t<li ng-repeat=\"(key, type) in product.category.ProductTypes\">\n\t\t\t<a ng-href=\"{{product.getUrl(type)}}\">{{type.NamePlural}}</a>\n\t\t</li>\n\t</ul>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/productCenter/pages/productdirectory/directoryBox/directoryBox.html
// module id = 310
// module chunks = 1